import React, { Component } from 'react';
import Select from 'react-select';
import MessageModal from './MessageModal';
import { connect } from 'react-redux';
import { changeAddressPolygon } from '../../actions/district';

class AdresWMS extends Component {

    constructor(props) {
        super(props);

        this.state = {
            dataDistrcit: null,
            selectedParcels: [],
            parcelFeatures: [],
            selectedAddress: null,
            adresses: null,
            district: this.props.district,
            showMessage: false,
            districtTeryt: '',
            dzialkaForCieszanow: [{
              display_name: 'Jana III Sobieskiego 1, Cieszanów, gmina Cieszanów, powiat lubaczowski, województwo podkarpackie, 37-611, Polska',
              lat: '50.244567',
              lon: '23.131705',
              value: 'Jana III Sobieskiego 1, Cieszanów, gmina Cieszanów, powiat lubaczowski, województwo podkarpackie, 37-611, Polska',
              label: 'Jana III Sobieskiego 1, Cieszanów, gmina Cieszanów, powiat lubaczowski, województwo podkarpackie, 37-611, Polska',
            },
            {
              display_name: 'Jana III Sobieskiego 3, Cieszanów, gmina Cieszanów, powiat lubaczowski, województwo podkarpackie, 37-611, Polska',
              lat: '50.244155161',
              lon: '23.1324005',
              value: 'Jana III Sobieskiego 3, Cieszanów, gmina Cieszanów, powiat lubaczowski, województwo podkarpackie, 37-611, Polska',
              label: 'Jana III Sobieskiego 3, Cieszanów, gmina Cieszanów, powiat lubaczowski, województwo podkarpackie, 37-611, Polska',
            },
            {
              display_name: 'Jana III Sobieskiego 5, Cieszanów, gmina Cieszanów, powiat lubaczowski, województwo podkarpackie, 37-611, Polska',
              lat: '50.244567',
              lon: '23.131705',
              value: 'Jana III Sobieskiego 5, Cieszanów, gmina Cieszanów, powiat lubaczowski, województwo podkarpackie, 37-611, Polska',
              label: 'Jana III Sobieskiego 5, Cieszanów, gmina Cieszanów, powiat lubaczowski, województwo podkarpackie, 37-611, Polska',
            },
            {
              display_name: 'Jana III Sobieskiego 7, Cieszanów, gmina Cieszanów, powiat lubaczowski, województwo podkarpackie, 37-611, Polska',
              lat: '50.244567',
              lon: '23.131705',
              value: 'Jana III Sobieskiego 7, Cieszanów, gmina Cieszanów, powiat lubaczowski, województwo podkarpackie, 37-611, Polska',
              label: 'Jana III Sobieskiego 7, Cieszanów, gmina Cieszanów, powiat lubaczowski, województwo podkarpackie, 37-611, Polska',
            },
            {
              display_name: 'Jana III Sobieskiego 1, Cieszanów, gmina Cieszanów, powiat lubaczowski, województwo podkarpackie, 37-611, Polska',
              lat: '50.244567',
              lon: '23.131705',
              value: 'Jana III Sobieskiego 1, Cieszanów, gmina Cieszanów, powiat lubaczowski, województwo podkarpackie, 37-611, Polska',
              label: 'Jana III Sobieskiego 1, Cieszanów, gmina Cieszanów, powiat lubaczowski, województwo podkarpackie, 37-611, Polska',
            },
            {
              display_name: 'Tadeusza Kościuszki 2, Cieszanów, gmina Cieszanów, powiat lubaczowski, województwo podkarpackie, 37-611, Polska',
              lat: '50.244567',
              lon: '23.131705',
              value: 'Tadeusza Kościuszki 2, Cieszanów, gmina Cieszanów, powiat lubaczowski, województwo podkarpackie, 37-611, Polska',
              label: 'Tadeusza Kościuszki 2, Cieszanów, gmina Cieszanów, powiat lubaczowski, województwo podkarpackie, 37-611, Polska',
            },
            {
              display_name: 'Tadeusza Kościuszki 4, Cieszanów, gmina Cieszanów, powiat lubaczowski, województwo podkarpackie, 37-611, Polska',
              lat: '50.244567',
              lon: '23.131705',
              value: 'Tadeusza Kościuszki 4, Cieszanów, gmina Cieszanów, powiat lubaczowski, województwo podkarpackie, 37-611, Polska',
              label: 'Tadeusza Kościuszki 4, Cieszanów, gmina Cieszanów, powiat lubaczowski, województwo podkarpackie, 37-611, Polska',
            },
            {
              display_name: 'Tadeusza Kościuszki 6, Cieszanów, gmina Cieszanów, powiat lubaczowski, województwo podkarpackie, 37-611, Polska',
              lat: '50.244567',
              lon: '23.131705',
              value: 'Tadeusza Kościuszki 6, Cieszanów, gmina Cieszanów, powiat lubaczowski, województwo podkarpackie, 37-611, Polska',
              label: 'Tadeusza Kościuszki 6, Cieszanów, gmina Cieszanów, powiat lubaczowski, województwo podkarpackie, 37-611, Polska',
            }
          ]
        }
      }
    // Pobieramy dane na temat dzialki
    getParcelInPoint = latlng => {
      let query = `${process.env.API_URL}/eservices/${this.state.districtTeryt.teryt}/parcel_in_point?lat=${latlng.lat}&lng=${latlng.lng}`;
      return fetch(query,{ type: 'GET' })
      .then(r => {
        if(r.status == 200) {
          return r.json();
        }
      })
      .catch(err => {
        this.setState({
          showMessage: true,
        });
      })
    }

    // Zmieniamy zawartosc inputa i state
    onChangeAddress = val => {

        this.getParcelInPoint({ lat: val.lat, lng: val.lon })
        .then(resp => {
          const parcel = {
            value: resp.properties.nr_dzialki,
            label: resp.properties.nr_dzialki,
            obreb: resp.properties.obreb,
          };
          this.setState({
            selectedParcels: parcel,
            selectedAddress: {value: resp.properties.nr_dzialki, label: val.display_name, obreb: resp.properties.obreb },
            parcelFeatures: resp });

            var geo = {
              "type": "Feature",
              "properties": resp.properties,
              "geometry": {
                  "type": "Polygon",
                  "coordinates": resp.geometry.coordinates
              }
            };
            this.props.changeAddressPolygon(geo)
        });
      }

      // Wczytujemy liste adresow do inputa
      inputAdressChange = e => {
        const query = `http://nominatim.openstreetmap.org/search/pl?format=json&q=${e}&accept-language=pl-PL&countrycodes=pl`;
        fetch(query, { method: 'GET' })
        .then(r => {
          return r.json();
        })
        .then(resp => {
          this.setState({ adresses: resp.map(address => {
            return { ...address, label: <span><img src={address.icon} alt="Address Icon" />{address.display_name}</span>, value: address.display_name };
          }) })}
        );

        this.setState({
          districtTeryt: _.find(this.props.districts, v => v == this.props.district.prefix)
        });
      }

    render() {
      const styles = {
        positin: 'relative',
        bottom: '0',
        left: '2%',

        color: '#aaa',
        lineHeight: '34px',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        borderRadius: '0',
        width: '100%'
      }
        return (
            <div>
                {this.state.showMessage ? <MessageModal openModal={this.state.showMessage} closeModal={() => this.setState({ showMessage: false })} /> : null}
                <Select
                    placeholder="Wpisz adres..."
                    name="form-field-name"
                    value={this.state.selectedAddress}
                    options={this.state.dzialkaForCieszanow}
                    clearable
                    onInputChange={this.inputAdressChange}
                    style={styles}
                    onChange={this.onChangeAddress}
                    onBlur={event => event.preventDefault()}
                    optionClassName="needsclick"
                    blurInputOnSelect={false}
                />
            </div>
        )
    }
}

const mapState = (state) => ({
  addressPolygon: state.district.district.addressPolygon,
  districts: state.district.districts
});

const mapDispatch = {
  changeAddressPolygon
};

// export default AdresWMS;
export default connect(mapState, mapDispatch)(AdresWMS);



// WEBPACK FOOTER //
// src/components/AdresWMS/AdresWMS.js